// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosPromise } from 'axios';
import * as util from './util';
import { Chapter, Progress } from '../types/Model';
import { authDelete, authGet, authPost, parseCamelCase, parseSnakeCase } from './util';
const baseURL = '/workshop';

export const getWorkshopData = (id: number): AxiosPromise => {
  return util.authGet(`${baseURL}/workshops/${id}/information`, {
    transformResponse: (workshop: any) => ({
      ...util.parseCamelCase(workshop),
      startTime: new Date(workshop.start_time),
      endTime: new Date(workshop.end_time)
    })
  });
};

interface WorkshopChapters {
  chapters: Chapter[];
  progress: Progress[];
}

export const getWorkshopContentsData = (id: number): AxiosPromise<WorkshopChapters> => {
  function parseQuiz(module: any) {
    if (module.type === 'quiz') {
      const answers = module.questions.map((question: any) =>
        question.options.reduce(
          (pre: string, cur: any, index: number) =>
            pre + (cur.answer ? String.fromCharCode(index + 65) : ''),
          ''
        )
      );
      const examData = module.questions.map((question: any) => ({
        title: question.description,
        options: question.options.map((option: any) => option.content)
      }));
      const explains = module.questions.map((question: any) => {
        return question.options.reduce(
          (pre: object, cur: any, index: number) => {
            if (cur.explain) {
              return {
                ...pre,
                [String.fromCharCode(index + 65)]: cur.explain
              };
            }
            return pre;
          },
          {}
        );
      });

      return {
        answers,
        examData,
        explains
      };
    }

    return {
      answers: [],
      examData: [],
      explains: []
    };
  }

  return util.authGet(`${baseURL}/workshops/${id}/contents`, {
    transformResponse: (data: any) => {
      if (typeof data === 'string') {
        throw data;
      }

      const {
        chapters,
        ...workshop
      } = util.parseCamelCase(data);
      console.log(chapters);
      const parsed = {
        ...workshop,
        chapters: chapters.map(
          ({ modules, ...chapter }: any, index: number) => ({
            id: index + 1,
            ...chapter,
            modules: modules.map((module: any) => ({
              ...module,
              videoUrl: module.videoUrls && module.videoUrls.hlsGroup,
              ...parseQuiz(module)
            }))
          })
        ),
      };

      return parsed;
    }
  });
};

interface UpdateProgress {
  revisedTime: Date;
  progress: Progress[];
}

export const updateWorkshopProgress = (id: number, progress: any): AxiosPromise<UpdateProgress> => {
  return util.authPost(`${baseURL}/workshops/${id}/progress`, util.parseSnakeCase(progress), {
    transformResponse: (data: any) => util.parseCamelCase(data)
  })
}

export const getWorkshopNotes = (id: number) => {
  return authGet(`${baseURL}/workshops/${id}/note`, {
    transformResponse: (note) => parseCamelCase(note)
  });
}

export const createWorkshopNotes = (id:number, vodId:number, time:number, note:string) => {
  return authPost(`${baseURL}/workshops/${id}/note`,
    parseSnakeCase({ vodId, note, time }), {
      transformResponse: (data: any) => parseCamelCase(data)
    })
}

export const updateWorkshopNotes = (id:number, noteId: string, note: string) => {
  return authPost(`${baseURL}/workshops/${id}/note/${noteId}`, parseSnakeCase({ note }), {
    transformResponse: (data: any) => parseCamelCase(data)
  })
}

export const deleteWorkshopNotes = (id:number, noteId: string) => {
  return authDelete(`${baseURL}/workshops/${id}/note/${noteId}`, {
    transformResponse: (data: any) => parseCamelCase(data)
  })
}

export const downloadWorkshopResult = (id:number, choosedUser: number[]) => {
  return authPost(`${baseURL}/workshops/${id}/downloadResult`, parseSnakeCase({
    choosedUser
  }), {
    responseType: 'blob',
  })
}
